import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayArea } from "../models/DelayArea";

export const getDelayAreas = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[DEL].[GetAssetsForDelayArea]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayArea[];
	} else {
		throw new Error(resp.message || "Error fetching delay areas");
	}
};
